/*
 * <lp-accordion> — native <details> accordions with a smooth grid-rows open/close animation.
 * When data-single="true", opening one item closes the others (like the reference).
 */
(function () {
  'use strict';
  class LPAccordion extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('details'));
      this.items.forEach((item) => {
        const summary = item.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', (e) => {
          e.preventDefault();
          if (item.open) this.close(item);
          else this.open(item);
        });
      });
    }
    duration() {
      return 300 * ((window.LPConfig && window.LPConfig.speed) || 0);
    }
    open(item) {
      if (this.dataset.single === 'true') this.items.forEach((o) => { if (o !== item && o.open) this.close(o); });
      item.classList.remove('is-closing');
      item.open = true;
    }
    close(item) {
      const d = this.duration();
      if (!d) { item.open = false; return; }
      item.classList.add('is-closing');
      clearTimeout(item._lpTimer);
      item._lpTimer = setTimeout(() => {
        item.open = false;
        item.classList.remove('is-closing');
      }, d);
    }
  }
  if (!customElements.get('lp-accordion')) customElements.define('lp-accordion', LPAccordion);

  document.addEventListener('shopify:block:select', (e) => {
    const item = e.target.closest && e.target.closest('details.lp-faq__item');
    const acc = item && item.closest('lp-accordion');
    if (acc) acc.open(item);
  });
})();